import React from "react";

interface TextInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "value" | "onChange"> {
    label?: string;
    type?: React.HTMLInputTypeAttribute; // Supports different input types
    value: string | number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
}

const TextInput: React.FC<TextInputProps> = ({
    label,
    type = "text",
    value,
    onChange,
    name,
    placeholder,
    className,
    ...inputProps
}) => {
    return (
        <div className="flex flex-col gap-1">
            {label && <label className="text-sm font-semibold">{label}</label>}
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                {...inputProps}
                className={`border px-3 py-2 rounded ${className}`}
            />
        </div>
    );
};

export default TextInput;
